import { render, staticRenderFns } from "./daoqitixing.vue?vue&type=template&id=623da42f&scoped=true"
import script from "./daoqitixing.vue?vue&type=script&lang=js"
export * from "./daoqitixing.vue?vue&type=script&lang=js"
import style0 from "./daoqitixing.vue?vue&type=style&index=0&id=623da42f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623da42f",
  null
  
)

export default component.exports